import proposals from '../../../api/proposals'
import clients from '../../../api/clients'
import companies from '../../../api/companies'
import * as types from '../../mutation-types'

// initial state
const state = {
	proposal: {},
	proposals: [],
	milestones: {},
	clients: [],
	client: {},
	companies: [],
	company: {},
}

// getters
const getters = {
	clients: state => state.clients,
	client: state => state.client,
	companies: state => state.companies,
	company: state => state.company,
	mainCompany: state => state.companies.find(c => c.isMain) || null,
	allProposals: state => state.proposals,
	proposal: state => state.proposal,
	milestones: state => {
		let milestones = state.proposal.milestones;

		if (!milestones) {
			milestones = {};
		}
		if (!milestones.items) {
			milestones.items = [];
		}
		return milestones;
	}
}

// actions
const actions = {
	initialState({ commit }) {
		state.client = {};
		state.proposal = {};
	},
	createClient({ commit }, payload) {
		let obj = payload;
		clients.createClient(obj, () => commit(types.CREATE_CLIENT, { obj }))
	},
	updateClient({ commit }, payload) {
		let obj = payload;
		clients.updateClient(obj, () => commit(types.UPDATE_CLIENT, { obj }))
	},
	setClient({ commit	}, payload) {
		let client = payload;
		commit(types.SET_CLIENT, { client })
	},
	getAllClients({ commit }) {
		clients.getClients(clients => {
			commit(types.RECEIVE_CLIENTS, { clients })
		})
	},
	getAllCompanies({ commit }) {
		companies.getCompanies(data => {
			commit(types.RECEIVE_COMPANIES, { data })
		})
	},
	createCompany({ commit }, payload) {
		companies.createCompany(payload, company => commit(types.CREATE_COMPANY, { company }))
	},
	updateCompany({ commit }, payload) {
		companies.updateCompany(payload, company => commit(types.UPDATE_COMPANY, { company }))
	},
	removeCompany({ commit }, payload) {
		companies.removeCompany(payload, id => commit(types.REMOVE_COMPANY, { id }))
	},
	getAllProposals({ commit }) {
		proposals.getProposals(proposals => {
			commit(types.RECEIVE_PROPOSALS, { proposals })
		})
	},
	getProposal({ commit }, proposalID) {
		const id = proposalID;
		proposals.getProposal(id, (proposal) => {
			if (state.proposal.id && state.proposal.id !== id) return;
			if (!proposal['Type']) proposal['Type'] = 'Angebot';
			commit(types.RECEIVE_PROPOSAL, { proposal })
		})
	},
	offProposal({ commit }, proposalID) {
		proposals.offProposal(proposalID);
	},
	createProposal({ commit }, payload) {
		let obj = payload;
		console.log(obj);
		proposals.createProposal(obj, (proposal) => commit(types.CREATE_PROPOSAL, { proposal }))
	},
	duplicateProposal({ commit }, payload) {
		const id = payload;
		proposals.duplicateProposal(id);
	},
	removeProposal({ commit }, payload) {
		const id = payload;
		proposals.removeProposal(id, () => commit(types.REMOVE_PROPOSAL, { id }));
	},
	updateProjectInfo({ commit }, payload) {
		let obj = payload;
		proposals.updateProjectInfo(obj, () => commit(types.UPDATE_PROJECT_INFO, { obj }))
	},
	updateConfirmation({ commit	}, payload) {
		let obj = payload;
		proposals.updateConfirmation(obj, () => commit(types.UPDATE_CONFIRMATION, { obj }))
	},
	updateMilestones({ commit }, payload) {
		let obj = payload.milestones;
		const id = payload.id;
		proposals.updateMilestones(obj, id, () => commit(types.UPDATE_MILESTONES, { obj }))
	},
	addPhase({ commit }, payload) {
		let milestone = payload;
		commit(types.ADD_PHASE, { milestone })
	},
	addChild({ commit }, payload) {
		let childValue = payload;
		commit(types.ADD_CHILD, { childValue })
	},
	addSibling({ commit }, payload) {
		let childValue = payload;
		commit(types.ADD_SIBLING, { childValue })
	},
	removeTile({ commit }, payload) {
		const id = payload;
		commit(types.REMOVE_TILE, { id })
	},
	switchWithUpperSibling({ commit }, payload) {
		const id = payload;
		commit(types.SWITCH_WITH_UPPER_SIBLING, { id })
	},
	switchWithLowerSibling({ commit }, payload) {
		const id = payload;
		commit(types.SWITCH_WITH_LOWER_SIBLING, { id })
	},
	shiftIn({ commit }, payload) {
		const id = payload;
		commit(types.SHIFT_IN, { id })
	},
	shiftOut({ commit }, payload) {
		const id = payload;
		commit(types.SHIFT_OUT, { id })
	},
	updatePrice({ commit }) {
		commit(types.UPDATE_PRICE)
	},
	updateTime({ commit	}) {
		commit(types.UPDATE_TIME)
	}
}

// mutations
const mutations = {
	[types.RECEIVE_COMPANIES](state, { data }) {
		var arr = Object.keys(data).map(key => data[key]);
		state.companies = arr.reverse();
	},
	[types.CREATE_COMPANY](state, { company }) {
		state.company = company;
	},
	[types.UPDATE_COMPANY](state, { company }) {
		state.company = company;
		const idx = state.companies.findIndex(c => c.id === company.id);
		if (idx !== -1) state.companies.splice(idx, 1, company);
	},
	[types.REMOVE_COMPANY](state, { id }) {
		state.companies = state.companies.filter(c => c.id !== id);
	},
	[types.CREATE_CLIENT](state, { client }) {
		state.client = client;
	},
	[types.UPDATE_CLIENT](state, { client }) {
		state.proposal['Client-Name'] = client['Client-Name'];
		state.proposal['Contact-Person'] = client['Contact-Person'];
		state.proposal['Place'] = client['Place'];
		state.proposal['Street'] = client['Street'];
	},
	[types.SET_CLIENT](state, { client }) {
		state.client = client;
		state.proposal['Client-Name'] = client['Client-Name'];
		state.proposal['Contact-Person'] = client['Contact-Person'];
		state.proposal['Place'] = client['Place'];
		state.proposal['Street'] = client['Street'];
	},
	[types.RECEIVE_CLIENTS](state, { clients }) {
		var arr = Object.keys(clients).map(function(key) {
			return clients[key];
		});
		state.clients = (arr.reverse());
	},
	[types.RECEIVE_PROPOSALS](state, { proposals }) {
		var arr = Object.keys(proposals).map(function(key) {
			return proposals[key];
		});
		state.proposals = (arr.reverse());
	},
	[types.RECEIVE_PROPOSAL](state, { proposal }) {
		state.proposal = proposal;
		state.milestones = proposal.milestones;
	},
	[types.CREATE_PROPOSAL](state, { proposal }) {
		state.proposal = proposal;
		state.milestones = proposal['milestones'];
	},
	[types.REMOVE_PROPOSAL](state, { id }) {
		state.proposal = {};
		state.milestones = {};
	},
	[types.UPDATE_PROJECT_INFO](state, { obj }) {
		updateProjectInfo(state, obj)
	},
	[types.UPDATE_CONFIRMATION](state, { obj }) {
		updateConfirmation(state, obj)
	},
	[types.UPDATE_MILESTONES](state, { obj }) {
		updateMilestones(state, obj)
	},
	[types.ADD_PHASE](state, { milestone }) {
		addPhase(state, milestone)
	},

	[types.ADD_CHILD](state, { childValue }) {
		addChild(state, childValue)
	},

	[types.ADD_SIBLING](state, { childValue }) {
		addSibling(state, childValue)
	},

	[types.SWITCH_WITH_UPPER_SIBLING](state, { id }) {
		switchWithUpperSibling(state, id)
	},

	[types.SWITCH_WITH_LOWER_SIBLING](state, { id }) {
		switchWithLowerSibling(state, id)
	},

	[types.SHIFT_OUT](state, { id }) {
		shiftOut(state, id)
	},

	[types.SHIFT_IN](state, { id }) {
		shiftIn(state, id)
	},

	[types.REMOVE_TILE](state, { id }) {
		removeTile(state, id)
	},

	[types.UPDATE_PRICE](state) {
		updatePrice(state)
	},

	[types.UPDATE_TIME](state) {
		updateTime(state)
	}
}

function updateProjectInfo(state, obj) {
	let projectIproposalnfo = state.proposal;
	console.log(obj);

	proposal = obj;
	// projectInfo[key] = projectInfo[key] || {}; projectInfo[key] = value;
}

function updateConfirmation(state, obj) {
	let confirmation = state.confirmation;
	let key = obj.key;
	let value = obj.value;

	confirmation[key] = confirmation[key] || {};
	confirmation[key] = value;
}

function updateMilestones(state, obj) {
	let milestones = state.milestones;
	milestones = obj.milestones;
}

function addPhase(state, milestone) {
	setID(state, milestone);

	if (!state.milestones.items) {
		state.milestones.items = [];
	}
	state.milestones.items.push(milestone);
}

function addChild(state, child) {
	let milestones = state.milestones.items;
	let parentID = child.values.parentID;
	let parent = findByID(milestones, parentID);

	setID(state, child);

	if (!parent.children) {
		parent.children = [];
	}
	parent.children.push(child);
}

function addSibling(state, child) {
	let milestones = state.milestones.items;
	let parentID = child.values.parentID;
	let parent = findByID(milestones, parentID);
	let grandParent = findByID(milestones, parent.values.parentID);

	child.values.parentID = parent.values.parentID;
	setID(state, child);

	// add phase
	if (!grandParent) {
		milestones.push(child);
		milestones = changeItemPositionInArr(milestones, findIndex(milestones, child.id), findIndex(milestones, parentID) + 1);
	// add milestone/bulletpoint
	} else {
		if (!grandParent.children) {
			grandParent.children = [];
		}
		grandParent.children.push(child);
		grandParent.children = changeItemPositionInArr(
			grandParent.children,
			findIndex(grandParent.children, child.id),
			findIndex(grandParent.children, parentID) + 1
		);
	}
}

function switchWithUpperSibling(state, id) {
	let milestones = state.milestones.items;
	let child = findByID(milestones, id);
	let parent = findByID(milestones, child.values.parentID);

	if (!parent) {
		let childIndex = milestones.findIndex(item => item.id !== undefined && item.id === id);
		if (childIndex !== 0) {
			milestones = swapArrayItems(milestones, childIndex - 1, childIndex);
		}

	} else if (parent.children.length > 1) {
		let childIndex = parent.children.findIndex(item => item.id === id);
		if (childIndex !== 0) {
			parent = swapArrayItems(parent.children, childIndex - 1, childIndex);
		}
	}
}

function switchWithLowerSibling(state, id) {
	let milestones = state.milestones.items;
	let child = findByID(milestones, id);
	let parent = findByID(milestones, child.values.parentID);

	if (!parent) {
		let childIndex = milestones.findIndex(item => item.id !== undefined && item.id === id);
		if (childIndex !== milestones.length - 1) {
			milestones = swapArrayItems(milestones, childIndex, childIndex + 1);
		}
	} else if (parent.children.length > 1) {
		let childIndex = parent.children.findIndex(item => item.id === id);
		if (childIndex !== parent.children.length - 1) {
			parent = swapArrayItems(parent.children, childIndex, childIndex + 1);
		}
	}
}

function shiftIn(state, id) {
	let milestones = state.milestones.items;
	let child = findByID(milestones, id);
	let parent = findByID(milestones, child.values.parentID);
	let childIndex = 0;
	console.log(parent, milestones);

	if (!parent) {
		if (milestones.length <= 1) return;

		childIndex = milestones.findIndex(item => item.id === id);
		let newParent = milestones[childIndex - 1];

		if(!newParent) return ;

		removeTile(state, id);
		child.values.parentID = newParent.id;
		if (newParent.children == undefined) {
			newParent.children = [];
		}
		newParent.children.push(child);

	} else {
		childIndex = parent.children.findIndex(item => item.id === id);
		let newParent = parent.children[childIndex - 1];

		if (!newParent) return;

		removeTile(state, id);
		child.values.parentID = newParent.id;

		if (newParent.children == undefined) {
			newParent.children = [];
		}
		newParent.children.push(child);
	}
}

function shiftOut(state, id) {
	let milestones = state.milestones.items;
	let child = findByID(milestones, id);

	//no parent
	if (!child.values.parentID) return;

	let parent = findByID(milestones, child.values.parentID);
	let grandParent = findByID(milestones, parent.values.parentID);
	removeTile(state, id);

	child.values.parentID = parent.values.parentID;

	//shiftOut to phase
	if (grandParent == null) {
		milestones.push(child);
	} else {
		grandParent.children.push(child);
	}
}

function removeTile(state, id) {
	let milestones = state.milestones.items;
	let child = findByID(milestones, id);
	let parent = findByID(milestones, child.values.parentID);
	let childIndex = 0;

	if (!parent) {
		childIndex = milestones.findIndex(item => item.id === id);
		milestones.splice(childIndex, 1);
		return;
	}

	childIndex = parent.children.findIndex(item => item.id === id);
	parent.children.splice(childIndex, 1);
}

function updatePrice(state) {
	let milestones = state.milestones;
	console.log('updating price');
	let price = 0;
	let taxes = {
		'5': 0,
		'7': 0,
		'16': 0,
		'19': 0,
	}
	let indices_notNumber = [];
	let optionalNum = 0;

	// find total price and taxes for all milestones
	for (let i = 0; i < milestones.items.length; i++) {
		let phase = milestones.items[i];
		let value = Number(phase.values.price);

		// save indices of phases with no number values in price field
		if (isNaN(value)) {
			indices_notNumber.push(i);
			continue;
		}

		phase.values['Price-Long'] = convertToCurrency(value);

		if (phase.values.optional) {
			optionalNum += 1;
			continue;
		}

		price += value;
		findTaxes(value, phase, taxes);

		let children = parent.children;
		if (!children)  continue;

		for (let i = 0; i < children.length; i++) {
			let child = children[i];
			let value = Number(child.values.price);

			if (isNaN(value) == NaN) continue;

			price += value;
		}
	}

	// find % value in euro and update total price
	for (let i of indices_notNumber) {
		let phase = milestones.items[i];
		let value = phase.values.price;

		if (value[value.length - 1] !== '%') continue;
		value = price * parseInt(value) / 100;
		phase.values['Price-Long'] = convertToCurrency(value);

		if (phase.values.optional) {
			optionalNum += 1;
			continue;
		}

		price += value;
		findTaxes(value, phase, taxes);
	}

	if (!indices_notNumber.length) {
		milestones['has-Percent-Phase'] = false;
	}

	// write all values to milestones properties
	if (!isNaN(price)) milestones.Price = price;
	milestones['Price-Netto'] = convertToCurrency(price);
	milestones['Price-Brutto'] = convertToCurrency(price + Object.values(taxes)
		.reduce((pv, cv) => pv + cv, 0));

	// convert taxes values to strings and save them in Taxes-X-Long milestones properties
	for (const [taxes_key, taxes_value] of Object.entries(taxes)) {
		milestones['Taxes-' + taxes_key + '-Long'] = taxes_value > 0 ? convertToCurrency(taxes_value) : 0;
	}
}

function findTaxes(value, phase, taxes) {
	const taxes_val = phase.values.taxes;

	if (taxes_val !== undefined) {
		// if milestone already has type of taxes set in property
		taxes[taxes_val] += value * taxes_val / 100;
	} else if (phase.values['Taxes-19']) {
		// if old system is used (only 7/19%)
		taxes['19'] += value * 0.19;
	} else {
		taxes['7'] += value * 0.07;
	}
}

function updateTime(state) {
	let milestones = state.milestones;
	let time = 0;
	let timeOptional = 0;
	milestones['Time-Optional'] = 0;

	for (let i = 0; i < milestones.items.length; i++) {
		let phase = milestones.items[i];
		let value = Number(phase.values.time);
		if (isNaN(value)) continue;

		phase.values['Time-Long'] = convertToWeek(value);

		if (phase.values.optional) {
			console.log(milestones['Time-Optional'], {value})
			timeOptional += value;
		} else {
			time += value;

			let children = phase.children;
			if (!children) continue;

			for (let i = 0; i < children.length; i++) {
				let child = children[i];
				let value = Number(child.values.time);

				if (isNaN(value)) continue;

				time += value;
			}
		}
	}

	milestones['Time'] = time;
	milestones['Time-Optional'] = timeOptional;
	milestones['Time-Long'] = convertToWeek(time);
}

function convertToCurrency(price) {
	let currency = price.toFixed(2).replace(/./g, (c, i, a) => {
		if (i && c !== "." && ((a.length - i) % 3 === 0)) {
			return ',' + c
		} else {
			return c
		}
	});

	currency = currency.replace(",", ".");

	let pos = currency.lastIndexOf('.');
	currency = "€ " + currency.substring(0, pos) + ',' + currency.substring(pos + 1);

	return currency;
}

function convertToWeek(value) {
	if (value === "") {
		return "";
	}
	value = String(value) || ""
	if (value.indexOf("Woche") === -1) {
		if (value === "1") {
			value += " Woche";
		} else {
			value += " Wochen";
		}
	}
	return value.replace(".", ",");
}

function convertToDays(value) {
	if (value === "") {
		return "";
	}
	value = String(value) || ""
	if (value.indexOf("Tage") === -1) {
		if (value === "1") {
			value += " Tag";
		} else {
			value += " Tage";
		}
	}
	return value;
}

// swap array items at positions i and j
function swapArrayItems(list, i, j) {
	let mList = list;
	[mList[i], mList[j]] = [mList[j], mList[i]];
	return mList;
}

// move item in array from position fromIndex to position toIndex
function changeItemPositionInArr(list, fromIndex, toIndex) {
	let mList = list;
	mList.splice(toIndex, 0, mList.splice(fromIndex, 1)[0]);
	return mList;
}

function findByID(o, id) {
	if (o.id === id) {
		return o;
	}
	let result;
	let p;

	for (p in o) {
		if (o.hasOwnProperty(p) && typeof o[p] === 'object') {
			result = findByID(o[p], id);
			if (result) {
				return result;
			}
		}
	}
	return result;
}

function setID(state, self) {
	self.id = ++state.milestones.id;

	//update every child.parentID to new parent id
	for (let child in self.children) {
		child.values.parentID = self.id;
	}
}

// find index of item with id
function findIndex(list, id) {
	return list.findIndex(item => item.id !== undefined && item.id === id);
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/index.js